import * as React from "react"
import { cn } from "@/lib/utils"
import { uppercaseText } from "@/lib/uppercase"

const UppercaseInput = React.forwardRef<
  HTMLInputElement,
  React.InputHTMLAttributes<HTMLInputElement>
>(({ className, type, onChange, ...props }, ref) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const start = e.target.selectionStart
    const end = e.target.selectionEnd
    e.target.value = uppercaseText(e.target.value)
    e.target.setSelectionRange(start, end)
    onChange?.(e)
  }

  return (
    <input
      type={type}
      className={cn(
        "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base uppercase shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground placeholder:normal-case focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      onChange={handleChange}
      {...props}
    />
  )
})
UppercaseInput.displayName = "UppercaseInput"

export { UppercaseInput }
